export const EMAIL_TEMP_LIST = "EMAIL_TEMP_LIST";
export const EMAIL_TEMP_LIST_SUCCESS = "EMAIL_TEMP_LIST_SUCCESS";
export const EMAIL_TEMP_LIST_FAIL = "EMAIL_TEMP_LIST_FAIL";

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

export const EMAIL_TEMP_ID = "EMAIL_TEMP_ID";
export const EMAIL_TEMP_ID_SUCCESS = "EMAIL_TEMP_ID_SUCCESS";
export const EMAIL_TEMP_ID_FAIL = "EMAIL_TEMP_ID_FAIL";

/* >>>>>>>>>>>Update User <<<<<<<<<<<<<<< */
export const UPDATE_EMAIL_TEMP = "UPDATE_EMAIL_TEMP";
export const UPDATE_EMAIL_TEMP_SUCCESS = "UPDATE_EMAIL_TEMP_SUCCESS";
export const UPDATE_EMAIL_TEMP_FAIL = "UPDATE_EMAIL_TEMP_FAIL";

/* >>>>>>>>Add User <<<<<<<<<<<<<<< */
export const ADD_EMAIL_TEMP = "ADD_EMAIL_TEMP";
export const ADD_EMAIL_TEMP_SUCCESS = "ADD_EMAIL_TEMP_SUCCESS";
export const ADD_EMAIL_TEMP_FAIL = "ADD_EMAIL_TEMP_FAIL";

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/
export const DELETE_EMAIL_TEMP = "DELETE_EMAIL_TEMP";
export const DELETE_EMAIL_TEMP_SUCCESS = "DELETE_EMAIL_TEMP_SUCCESS";
export const DELETE_EMAIL_TEMP_FAIL = "DELETE_EMAIL_TEMP_FAIL";

//  sms //

export const SMS_TEMP_LIST = "SMS_TEMP_LIST";
export const SMS_TEMP_LIST_SUCCESS = "SMS_TEMP_LIST_SUCCESS";
export const SMS_TEMP_LIST_FAIL = "SMS_TEMP_LIST_FAIL";

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

export const SMS_TEMP_ID = "SMS_TEMP_ID";
export const SMS_TEMP_ID_SUCCESS = "SMS_TEMP_ID_SUCCESS";
export const SMS_TEMP_ID_FAIL = "SMS_TEMP_ID_FAIL";

/* >>>>>>>>>>>Update User <<<<<<<<<<<<<<< */
export const UPDATE_SMS_TEMP = "UPDATE_SMS_TEMP";
export const UPDATE_SMS_TEMP_SUCCESS = "UPDATE_SMS_TEMP_SUCCESS";
export const UPDATE_SMS_TEMP_FAIL = "UPDATE_SMS_TEMP_FAIL";

/* >>>>>>>>Add User <<<<<<<<<<<<<<< */
export const ADD_SMS_TEMP = "ADD_SMS_TEMP";
export const ADD_SMS_TEMP_SUCCESS = "ADD_SMS_TEMP_SUCCESS";
export const ADD_SMS_TEMP_FAIL = "ADD_SMS_TEMP_FAIL";

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/
export const DELETE_SMS_TEMP = "DELETE_SMS_TEMP";
export const DELETE_SMS_TEMP_SUCCESS = "DELETE_SMS_TEMP_SUCCESS";
export const DELETE_SMS_TEMP_FAIL = "DELETE_SMS_TEMP_FAIL";

/* >>>>>>>>>>>>>> EMAIL TEMP BY TYPE >>>>>>>>>>>>>>>*/
export const EMAIL_TEMP_BY_TYPE = "EMAIL_TEMP_BY_TYPE";
export const EMAIL_TEMP_BY_TYPE_SUCCESS = "EMAIL_TEMP_BY_TYPE_SUCCESS";
export const EMAIL_TEMP_BY_TYPE_FAIL = "EMAIL_TEMP_BY_TYPE_FAIL";

/* >>>>>>>>>>>>>> SMS TEMP BY TYPE >>>>>>>>>>>>>>>*/
export const SMS_TEMP_BY_TYPE = "SMS_TEMP_BY_TYPE";
export const SMS_TEMP_BY_TYPE_SUCCESS = "SMS_TEMP_BY_TYPE_SUCCESS";
export const SMS_TEMP_BY_TYPE_FAIL = "SMS_TEMP_BY_TYPE_FAIL";
